import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_get_request_xml_by_requestId_editorService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { requestId: string }): 
  Promise<{ result: { RequestId?: string, ErrorMessage?: string, Project?: string, ReferenceCode?: string, RequestXml?: string, Warehouse?: string } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.requestId)) {
      $missingRequiredInParams.push('\'requestId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      requestId: string    }) {
        if(isNil($inParams.requestId)) {
          return true; 
        }
      return false;
    }
}
